import { DateRange, DateRangePicker, PickersShortcutsItem, SingleInputDateRangeField } from '@mui/x-date-pickers-pro';
import { Controller } from 'react-hook-form';
import dayjs, { Dayjs } from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(weekOfYear);
dayjs.extend(quarterOfYear);
dayjs.extend(isoWeek);

export const shortcutsItems: PickersShortcutsItem<DateRange<Dayjs>>[] = [
  {
    label: 'Today',
    getValue: () => {
      const today = dayjs();
      return [today.startOf('day'), today.endOf('day')];
    },
  },
  {
    label: 'This Week',
    getValue: () => {
      const today = dayjs();
      return [today.startOf('isoWeek'), today.endOf('isoWeek')];
    },
  },
  {
    label: 'Last Week',
    getValue: () => {
      const lastWeek = dayjs().subtract(1, 'week');
      return [lastWeek.startOf('isoWeek'), lastWeek.endOf('isoWeek')];
    },
  },
  {
    label: 'This Month',
    getValue: () => {
      const today = dayjs();
      return [today.startOf('month'), today.endOf('month')];
    },
  },
  {
    label: 'Last Month',
    getValue: () => {
      const lastMonth = dayjs().subtract(1, 'month');
      return [lastMonth.startOf('month'), lastMonth.endOf('month')];
    },
  },
  {
    label: 'This Quarter',
    getValue: () => {
      const today = dayjs();
      return [today.startOf('quarter'), today.endOf('quarter')];
    },
  },
  {
    label: 'Last Quarter',
    getValue: () => {
      const lastQuarter = dayjs().subtract(1, 'quarter');
      return [lastQuarter.startOf('quarter'), lastQuarter.endOf('quarter')];
    },
  },
  // {
  //     label: 'This Year',
  //     getValue: () => {
  //         const today = dayjs();
  //         return [today.startOf('year'), today.endOf('year')];
  //     },
  // },
  // {
  //     label: 'Last Year',
  //     getValue: () => {
  //         const lastYear = dayjs().subtract(1, 'year');
  //         return [lastYear.startOf('year'), lastYear.endOf('year')];
  //     },
  // },
  { label: 'Reset', getValue: () => [null, null] },
];

const DateRangePro = ({
  methods,
  name
}: {
  methods: any
  name: string
}) => {


  return (
    <Controller
      name={name}
      control={methods.control}
      defaultValue={{}}
      render={({ field }: any) => (
        <DateRangePicker
          {...field}
          calendars={2}
          slotProps={{
            field: SingleInputDateRangeField,
            shortcuts: {
              items: shortcutsItems,
            },
            actionBar: {
              actions: ['clear'],
            },
            // toolbar: {
            //     toolbarFormat: 'YYYY',
            //     toolbarPlaceholder: '??',
            // },
            // calendarHeader: { sx: { border: '1px red solid' } }
          }}

        // value={dateRangeOnChange}
        // onChange={setDateRangeOnChange}
        />

      )}
    />
  )
}

export default DateRangePro